import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CloseIcon} from 'shells/icon/svg/close-icon';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {ModalLightbox} from 'shells/modal/modal-lightbox';
import {EmailPreviewHeader} from 'shells/timeline/ribbon/email-preview-header';

import {GetEmailDetails} from '../../../email/mailbox/get-email-details';

import styles from './queued-email-preview-modal.module.css';

type Props = {
    onClose: () => any;
    emailId: string;
};

export function QueuedEmailPreviewModal(props: Props) {
    return (
        <GetEmailDetails emailId={props.emailId} isQueued={true}>
            {({emailMessage, isLoading}) => {
                return (
                    <ModalLightbox onClose={props.onClose}>
                        <div className={styles['modal-container']}>
                            <button onClick={props.onClose} data-tip='Close'>
                                <CloseIcon size={17} />
                            </button>
                            <div className={styles['message-preview']}>
                                {isLoading ? (
                                    <div className={styles.loading}>
                                        <LoadingIcon fill={colors.greyLt} />
                                    </div>
                                ) : undefined}
                                {emailMessage ? (
                                    <>
                                        <EmailPreviewHeader
                                            actor={emailMessage.from}
                                            verb={'is scheduled to email'}
                                            participants={emailMessage.to}
                                            subject={emailMessage.subject}
                                            scheduledTime={
                                                emailMessage.timestamp
                                                    ? emailMessage.timestamp
                                                    : undefined
                                            }
                                        />
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: emailMessage.bodyHtml,
                                            }}
                                            className={styles['message-content']}
                                        />
                                    </>
                                ) : undefined}
                            </div>
                        </div>
                    </ModalLightbox>
                );
            }}
        </GetEmailDetails>
    );
}
